export default __webpack_public_path__ + "static/media/users-new.92330107.svg";